export enum OfferApplicationType {
    ITEM = "ITEM",
    CART = "CART",
    ORDER = "ORDER"
}
